import { useGetList } from "ra-core";

import type { Contact, ContactNote } from "../types";
import { DashboardStepper } from "./DashboardStepper";
import { DesktopHome } from "./home/DesktopHome";

/**
 * Desktop home (MobileDashboard renders phones). Two views share the page:
 * A «Hoy» (default) and B «Pulso», switched from the header toggle
 * (home/HomeViewToggle) with the default picked in Settings. The onboarding
 * stepper shows on top until there is a contact and a note.
 */
export const Dashboard = () => {
  const {
    data: dataContact,
    total: totalContact,
    isPending: isPendingContact,
  } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });
  const { total: totalContactNotes, isPending: isPendingContactNotes } =
    useGetList<ContactNote>("contact_notes", {
      pagination: { page: 1, perPage: 1 },
    });

  if (isPendingContact || isPendingContactNotes) {
    return null;
  }

  return (
    <div className="desk-dashboard">
      {!totalContact ? (
        <DashboardStepper step={1} />
      ) : !totalContactNotes ? (
        <DashboardStepper step={2} contactId={dataContact?.[0]?.id} />
      ) : null}
      <DesktopHome />
    </div>
  );
};
